export const IMPORT_PLACEHOLDER_EMAIL_DOMAIN = "@import.donequick.local";

export function isPlaceholderEmployeeEmail(email) {
  const normalized = String(email || "").trim().toLowerCase();
  return normalized !== "" && normalized.endsWith(IMPORT_PLACEHOLDER_EMAIL_DOMAIN);
}

export function isMissingEmployeeEmail(email) {
  const normalized = String(email || "").trim();
  return normalized === "" || isPlaceholderEmployeeEmail(normalized);
}

export function hasEmployeeLogin(employee) {
  return !!(employee?.user_id || employee?.user?.id);
}

/** Portal can sign in: linked user, employment Active, user account Active. */
export function hasActiveEmployeePortalAccess(employee) {
  if (!hasEmployeeLogin(employee)) {
    return false;
  }

  const employmentStatus = String(employee?.status ?? "").trim().toLowerCase();
  if (employmentStatus !== "active") {
    return false;
  }

  const userStatus = String(employee?.user?.status ?? "").trim().toLowerCase();
  if (userStatus !== "" && userStatus !== "active") {
    return false;
  }

  if (employee?.is_active === false) {
    return false;
  }

  return true;
}

export function isReadyForLoginInvite(employee) {
  if (hasEmployeeLogin(employee)) return false;
  const status = String(employee?.status || "").toLowerCase();
  if (status !== "active") return false;
  const email = String(employee?.email || "").trim();
  if (isMissingEmployeeEmail(email)) return false;
  // basic format check; server re-validates
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
}
